import { useEffect } from 'react';
import { css } from '@emotion/core';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { Typeahead, FloatingMenu, } from '@zapier/design-system';
import { useAppSearchData } from './useAppSearchData';
import { ServiceIcon } from '../ServiceIcon';
const Styles = labelStyles('ServiceTypeahead', {
    serviceIcon: css `
    &[data-disabled] {
      opacity: 0.6;
    }
  `,
});
const emptyItem = {
    disabled: true,
    name: 'No search results found.',
};
export const ServiceTypeahead = (props) => {
    const { ariaLabel, disabledText, initialSelectedItem, inputId, isDisabled, labelId, menuAriaLabel, onChange, onResultsUpdate, placeholder, slugFilter, excludeUpcoming, resultsLimit, setClearSelection, size, } = props;
    const getIconUrlForItem = (item) => item.images.url_32x32;
    const getLabelForItem = (item) => item.name;
    const renderIcon = (item) => {
        if (!item || !item.images) {
            return null;
        }
        return (isolateComponent("span", { css: Styles.serviceIcon, "data-disabled": isDisabled ? '' : undefined },
            isolateComponent(ServiceIcon, { ariaHidden: true, serviceName: getLabelForItem(item), size: 30, src: getIconUrlForItem(item) })));
    };
    const { apps, loading, onSearch, searchQuery } = useAppSearchData({
        limit: resultsLimit,
        searchDebounceDelay: 300,
        excludeUpcoming,
        useQuery: props.useQuery,
    });
    useEffect(() => {
        if (!loading && searchQuery.length && onResultsUpdate) {
            onResultsUpdate(searchQuery, apps);
        }
    }, [apps, loading, onResultsUpdate, searchQuery]);
    const filteredApps = !slugFilter
        ? apps
        : apps.filter((app) => app.slug !== slugFilter);
    const hasZeroResults = loading === false && searchQuery.length > 0 && filteredApps.length === 0;
    const displayedApps = hasZeroResults ? [emptyItem] : filteredApps;
    return (isolateComponent(Typeahead, { ariaLabel: ariaLabel, autoComplete: "off", disabledText: disabledText, getLabelForItem: getLabelForItem, id: props.id, initialSelectedItem: initialSelectedItem, inputId: inputId, isBusy: loading, isDisabled: isDisabled, items: loading || searchQuery === '' ? [] : displayedApps, labelId: labelId, menuAriaLabel: menuAriaLabel, onChange: onChange, onInputValueChange: (query) => onSearch(query), placeholder: placeholder, renderFloatingMenu: (menuProps) => props.renderFloatingMenu(Object.assign(Object.assign({}, menuProps), { visibleItems: resultsLimit })), renderIcon: renderIcon, setClearSelection: setClearSelection, showEmptyList: true, size: size }));
};
ServiceTypeahead.defaultProps = {
    excludeUpcoming: true,
    onResultsUpdate: () => { },
    renderFloatingMenu: (props) => isolateComponent(FloatingMenu, Object.assign({}, props)),
    resultsLimit: 4,
};
//# sourceMappingURL=ServiceTypeahead.js.map
// @zapier/design-system-patterns@4.9.1 (4902ab0c1)
